import {Organization} from './organization.model';

export enum WorkExperienceType {
  EDUCATION = 'EDUCATION',
  EXPERIENCE = 'EXPERIENCE',
}

export class JobTitle {
  id: string;
  active: boolean;
  createdBy: string;
  name: string;
  createdAt?: Date;
  updatedAt?: Date;

  constructor(json: any) {
    this.id = json.id || json._id;
    this.active = json.active || true;
    this.createdBy = json.createdBy;
    this.name = json.title || json.name;
    this.createdAt = json.createdAt ? new Date(json.createdAt) : undefined;
    this.updatedAt = json.updatedAt ? new Date(json.updatedAt) : undefined;
  }
}

export class WorkExperience {
  active: boolean;
  employmentTenure: string;
  id: string;
  isCurrentlyWorking: boolean;
  jobDescription: string;
  jobTitle: JobTitle;
  organization: Organization;
  type: WorkExperienceType;
  location?: string;
  constructor(json: any) {
    this.active = true;
    this.employmentTenure = json.employmentTenure;
    this.id = json.id || json._id;
    this.isCurrentlyWorking = json.isCurrentlyWorking;
    this.jobDescription = json.jobDescription;
    this.jobTitle = new JobTitle(json.jobTitle);
    this.organization = new Organization(json.organization);
    this.type = json.type;
    this.location = json.location;
  }
}

export type GroupedWorkExperienceByOrganization = {
  [organizationId: string]: {
    organization: Organization;
    roles: WorkExperience[];
  };
};
